<template>
	<div class="page_container flex_wrap column j_c_between a_i_center">
		<modal
			title="操作提示"
			v-model="orderModal.Show"
			:mask-closable="false"
			@on-ok="(orderModal.Show = false), bindOrderToDriver(orderModal.DriverName, orderModal.OrderId, 1)"
			@on-cancel="(orderModal.Show = false), bindOrderToDriver(orderModal.DriverName, orderModal.OrderId, 0)"
		>
			<p>是否要发送订单到红旗平台？</p>
		</modal>


		<header class="title">
			<h1>接送查询</h1>
			<div class="filtrate_wrap flex_wrap wrap">
				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="dateType" style="color: #000000 !important;background: #FFFFFF !important;">
						<option :value="item.value" v-for="(item, index) in dateSelection" :key="index" style="color: #000000 !important;background: #FFFFFF !important;">{{ item.text }}</option>
					</select>
				</div>
				<!-- 				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" name="sel_ModelType" id="Sel_ModelType">
					</select>
				</div> -->
				<!-- 				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" name="Sel_StatInterval" id="Sel_StatInterval">
						<option value="day">日统计</option>
						<option value="month">月统计</option>
						<option value="year">年统计</option>
					</select>
				</div> -->
				<div class="date_wrap flex_wrap a_i_center j_c_around">
					<input class="date" type="date" v-model="startDate":disabled="isLimit" style="color: #000000 !important;background: #FFFFFF !important;" />
					<span class="">至</span>
					<input class="date" type="date" v-model="endDate" :disabled="isLimit" style="color: #000000 !important;background: #FFFFFF !important;" />
				</div>
				<!-- <div class="btn_wrap flex_wrap"><button style="width: 95px;" class="btn demand_btn" @click="getStatData">查 询 统 计</button></div> -->
        <div><button @click="getStatData">查 询 统 计</button></div>

				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="limitType" style="color: #000000 !important;background: #FFFFFF !important;">
						<option :value="item.value" v-for="(item, index) in limitSelection" :key="index" style="color: #000000 !important;background: #FFFFFF !important;">{{ item.text }}</option>
					</select>
				</div>
				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<!-- 开始 --><span style="color: #ffffff;">开始</span>
					<input class="date" type="time" v-model="startTime" style="color: #000000 !important;background: #FFFFFF !important;" />
					<!-- 结束 --><span style="color: #ffffff;">结束</span>
					<input class="date" type="time" v-model="endTime" style="color: #000000 !important;background: #FFFFFF !important;" />
				</div>
				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="isGo" style="color: #000000 !important;background: #FFFFFF !important;">
						<option value="1" style="color: #000000 !important;background: #FFFFFF !important;">去程</option>
						<option value="0" style="color: #000000 !important;background: #FFFFFF !important;">返程</option>
					</select>
				</div>

				<!-- <div class="btn_wrap flex_wrap"><button style="width: 95px;" class="btn demand_btn" @click="getLimitDateList">显示限制时间</button></div>
				<div class="btn_wrap flex_wrap"><button style="width: 95px;" class="btn demand_btn" @click="addLimit">添加限制时间</button></div> -->

        <div><button @click="getLimitDateList">显示限制时间</button></div>
        <div><button @click="addLimit">添加限制时间</button></div>

			</div>
		</header>

		<div class="index_content">
			<h3 v-if="statData && statData.length && statData.length > 0">统计列表</h3>
			<div class="table statistics_table" v-if="statData && statData.length && statData.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">日期</li>
					<li class="th">S去</li>
					<li class="th">S返</li>
					<li class="th">L去</li>
					<li class="th">L返</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in statData" :key="index">
					<li class="td" @click="getReportData(record.day)">{{ record.day }}</li>
					<li class="td" @click="getInfoReport(record.day, 1, 1)">{{ record.shortGoCount }}</li>
					<li class="td" @click="getInfoReport(record.day, 1, 0)">{{ record.shortBackCount }}</li>
					<li class="td" @click="getInfoReport(record.day, 0, 1)">{{ record.longGoCount }}</li>
					<li class="td" @click="getInfoReport(record.day, 0, 0)">{{ record.longBackCount }}</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th">合计</li>
					<li class="th">{{ this.totalShortGoCount }}</li>
					<li class="th">{{ this.totalShortBackCount }}</li>
					<li class="th">{{ this.totalLongGoCount }}</li>
					<li class="th">{{ this.totalLongBackCount }}</li>
				</ul>
			</div>

			<h3 v-if="reportData && reportData.length && reportData.length > 0">接送列表</h3>
			<div class="table statistics_table" v-if="reportData && reportData.length && reportData.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">预约时间</li>
					<li class="th">订单类型</li>
					<li class="th">出发地</li>
					<li class="th">目的地</li>
					<li class="th">价格</li>
					<li class="th">客户名</li>
				</ul>

				<ul class="tr flex_wrap" v-for="(record, index) in reportData" :key="index" @click="bindDriverToAppointOrder(record)" :style="{background:(record.OrderState==2||record.OrderState==3?'black':'')}">
					<li class="td">{{ record.bookingDate }}</li>
					<li class="td">{{ orderTypeList[record.OrderType] + getOrderStationType(record.FromParams) }}</li>
					<li class="td">{{ record.bookingStartAddr }}</li>
					<li class="td">{{ record.bookingEndAddr }}</li>
					<li class="td">{{ record.TotalPrice + '-' + record.DriverName }}</li>
					<li class="td">{{ record.Contact }}</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th">合计</li>
					<li class="th">短途</li>
					<li class="th">{{ shortCount }}单</li>
					<li class="th">长途</li>
					<li class="th">{{ longCount }}单</li>
					<li class="th">{{ totalPrice }}元</li>
				</ul>

        <Modal
          v-model="showinfo"
          title="客人信息"
          class='showinfo'
          @on-ok="Isok">
          <p>订单状态：{{orderstatetype[customInfo.OrderState]}}</p>
          <p>下单时间：{{customInfo.CreateDate}}</p>
          <p>下单人：{{customInfo.Contact}}</p>
          <p>下单人电话：{{customInfo.riderPhone}}</p>
          <p>乘大巴人：{{this.busPeople}}</p>
          <p>乘大巴人电话：{{this.busPhone}}</p>
          <p>大巴时间：{{this.busTime}}</p>
          <p>出发地：{{customInfo.bookingStartAddr}}</p>
          <p>目的地：{{customInfo.bookingEndAddr}}</p>
          <div v-if="hisDriverTable == ''" style="font-size:0.38rem;">第一次乘坐接送车！</div>
          <div v-if="hisDriverTable != ''" v-for="(item, index) in hisDriverTable" :key="index" style="border: 1px solid gray;">
            <div style="display: flex;font-size:0.38rem;">
              <div style="border-right: 1px solid gray;width: 50%;">{{item.bookingDate}}</div>
              <div style="width: 50%;">{{item.DriverName}}</div>
            </div>
          </div>
          <!-- <button v-if="refundShow==false" @click="applyrefund(customInfo.bookingEndAddr)" style="background: red;color: white;margin-top: 10px;border: #E5E5EE 1px solid;border-radius: 10px;padding: 5px;">申请退票</button> -->
          <!-- <p>最近接送日期：{{this.carTime}}</p>
          <p>历史接送司机：{{this.carDriver}}</p> -->
        </Modal>

			</div>

			<h3 v-if="limitDate && limitDate.length && limitDate.length > 0">限制时间列表</h3>
			<div class="table statistics_table" v-if="limitDate && limitDate.length && limitDate.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">添加人</li>
					<li class="th">限制类型</li>
					<li class="th">开始时间</li>
					<li class="th">结束时间</li>
					<li class="th">操作</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in limitDate" :key="index">
					<li class="td">{{ record.Operator }}</li>
					<li class="td">{{ limitTypeList[record.LimitType] + (record.IsGo ? '去程' : '返程') }}</li>
					<li class="td">{{ record.LimitStartDate }}</li>
					<li class="td">{{ record.LimitEndDate }}</li>
					<li class="td" @click="invalidRecord(record.ID)">删除</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
					<li class="th"></li>
				</ul>
			</div>
		</div>
		<footer class=""></footer>
	</div>
</template>

<script>
import baseTool from '@/utils/baseFunction';
import appointApi from '@/request/appointApi';
import { mapState } from 'vuex';
export default {
	name: 'PickupReportList',
	data() {
		return {
			startDate: '',
			endDate: '',
			dateType: 'set',
      orderstatetype:['待支付','已支付','已完成','申请退款','已退款'],
			dateSelection: [{ text: '预约日期', value: 'set' }, { text: '下单日期', value: 'create' }],
			limitSelection: [{ text: '限制接送', value: '0' }, { text: '限制包车', value: '1' }],
			statData: [],
			reportData: [],
			limitDate: [],
			// fromParams: '',
			orderTypeList: ['随意约', '车票接送', '长途接送', '单接送'],
			limitTypeList: ['接送限制', '包车限制'],
			token: '',
			shortCount: 0,
			longCount: 0,
			totalPrice: 0,
			limitType: 0,
			startTime: '00:00',
			endTime: '23:59',
			isGo: 1,
			driverList: [],
			orderModal: {
				Show: false,
				OrderId: 0,
				DriverName: ''
			},
			limitList: [
        'oDcOv58kUAzt5R41TXh3dMHkpMn0',
        'oDcOv5zC_N25OIUWf8BxUjYStfCo',
        'oDcOv54xoytxmlssNHpOZFae-v98',
        // 'oDcOv57DvUXxlkVYSN3crPY3GyrU',
        // 'oDcOv57N6MNSYQ_mC6aWm22RMmMA',
        // 'oDcOv5-_qOULIa83Eu1mJ1hHmQlc',
        // 'oDcOv5-RHuQ9KpuuFWigz9OJJ59M',
        'oDcOv58FNF3hahDwcRre1zGaNc30',
        // 'oDcOv5_QLaHP4C5GxCjB5QkbGnnI',
        // 'oDcOv56qU_gCqSOzWOsqDa0ngxsk',
        'oDcOv53CF-i3W8SwTwk7gmDCnCQs',
        // 'oDcOv518urXrhW68jr11kRNXD_4Q',
        // 'oDcOv571_57f_828sZRDE9W4i0_Y',
        // 'oDcOv5yGc-Ceh9oaF5b1V6J4uMwA',
        // 'oDcOv57WdhufWlnKGXORwoAXMUoQ',
        // 'oDcOv51E6rLOtckXC9LIzVjYRySw',
        // 'oDcOv57zMLIpqqkaELTg6-3rREQo',
        'oDcOv5_7_W2zGAai1u9IiEZr4frQ',
        'oDcOv54zMhb84E4nF5QIQI7jJKyQ',
        'opz0c5JiBNEIDzZQ_MEqd0FRcO5E',
        'oDcOv5wzSPhI9T1IwG1kMM5KeWKM',
        // 'oDcOv54bj6xRb0Y1Z_ArqSpsNYiU',
        'oDcOv50GwEWF3eU4NGWMeNvP4nFU',
		       'oDcOv56vfxVtBUftWGclGpY4VJHo',
			],
      //进入页面控制
			enableList: [
				//'oDcOv54-HL9VoWh1_Ukynkw4QvaM',
				'oDcOv58kUAzt5R41TXh3dMHkpMn0',
				'oDcOv5zC_N25OIUWf8BxUjYStfCo',
        'oDcOv58FNF3hahDwcRre1zGaNc30',
        'oDcOv54xoytxmlssNHpOZFae-v98',
				// 'oDcOv57DvUXxlkVYSN3crPY3GyrU',
				// 'oDcOv57N6MNSYQ_mC6aWm22RMmMA',
				// 'oDcOv5-_qOULIa83Eu1mJ1hHmQlc',
				// 'oDcOv5-RHuQ9KpuuFWigz9OJJ59M',
				// 'oDcOv5_QLaHP4C5GxCjB5QkbGnnI',
				// 'oDcOv56qU_gCqSOzWOsqDa0ngxsk',
				//'oDcOv53CF-i3W8SwTwk7gmDCnCQs',
				// 'oDcOv518urXrhW68jr11kRNXD_4Q',
				// 'oDcOv571_57f_828sZRDE9W4i0_Y',
				// 'oDcOv5yGc-Ceh9oaF5b1V6J4uMwA',
				// 'oDcOv57WdhufWlnKGXORwoAXMUoQ',
				// 'oDcOv51E6rLOtckXC9LIzVjYRySw',
				// 'oDcOv57zMLIpqqkaELTg6-3rREQo',
        'oDcOv5_7_W2zGAai1u9IiEZr4frQ',
        'oDcOv54zMhb84E4nF5QIQI7jJKyQ',
        'opz0c5JiBNEIDzZQ_MEqd0FRcO5E',
        'oDcOv5wzSPhI9T1IwG1kMM5KeWKM',
    //     'oDcOv54bj6xRb0Y1Z_ArqSpsNYiU',
        'oDcOv50GwEWF3eU4NGWMeNvP4nFU',
		   'oDcOv56vfxVtBUftWGclGpY4VJHo',
		    'oDcOv5zW49tWwVTYtfz49ZMvBNAk',
			],
			enableNameList: [
			//	'黄得源',
				'林达志',
				'钱凯园',
        '何诗雅',
        '招振凤',
				// '罗志一',
				// '郭堃怡',
				// '霍桂峰',
				// '廖曼莉',
				// '吴理强',
				// '梁浩民',
				//'王李特',
				// '罗爱玲',
				// '雷沛婷',
				// '吴瑞彬',
				// '李丹艳',
				// '朱姐',
				// '温富强',
        '周静',
        '王弘臣',
        '周静',
        '梁灏锋',
    //     '梁灏锋',
        '谭功明',
		        '刘武力',
				   '吴振辉',
			],
			isLimit: true,
      showinfo:false,
      DriverList:[],
      customInfo:[],
      busPeople:'',
      busPhone:'',
      busTime:'',
      hisDriverTable:[],
      applyRefund:['oDcOv58FNF3hahDwcRre1zGaNc30'],
      refundShow:false,
		};
	},
	activated() {
		this.startDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.endDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.getDriverList();
		this.tmpTimer = setInterval(() => {
			if (this.OpenId && this.OpenId.length > 0) {

        if (this.applyRefund.indexOf(this.OpenId) != -1) {
          this.refundShow = true;
        }


				clearInterval(this.tmpTimer);
				if (this.enableList.indexOf(this.OpenId) == -1) {
					// 直接
					alert('走错路了抱歉！');
					this.$router.push({
						name: 'MainIndexPage'
					});
				} else {
					if (this.limitList.indexOf(this.OpenId) != -1) {
						this.isLimit = false;
					}
				}
			}
		}, 500);
	},
	methods: {
		getOrderStationType(params) {
			if (params != '' && params.length == 11) {
				return '[现场]';
			} else if (params == '') {
				return '[公众号]';
			} else if (params.length < 11 && params.length > 0) {
				return '[车上]';
			}
		},
		getDriverList() {
			appointApi.getDriverList().then(sucRes => {
				if (sucRes.success) {
					this.driverList = sucRes.data;
				}
			});
		},
		getStatData() {
			this.statData = [];
			appointApi.getAppointStatReportList(this.$store.state.user.OpenId, this.startDate, this.endDate, this.dateType).then(sucRes => {
				if (sucRes.success) {
					this.statData = sucRes.data;
				}
			});
		},
		getInfoReport(dateTime, isShort, isGo) {
			this.reportData = [];
			this.limitDate = [];
			this.shortCount = 0;
			this.longCount = 0;
			this.totalPrice = 0;
			appointApi.getAppointOrderListByStat(this.token, dateTime, isShort, isGo).then(sucRes => {
				if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
					sucRes.data.forEach(val => {
						let tmpDate = val.bookingDate.replace('T', ' ');
						let tmpDateStr = tmpDate.split(' ')[0];
						let tmpTimeStr = tmpDate.split(' ')[1];
						val.bookingDate = tmpDateStr + ' ' + tmpTimeStr.split(':')[0] + ':' + tmpTimeStr.split(':')[1];
            // val.bookingDate = ' '+val.bookingDate.substring(5, 21)
						// val.bookingDate = baseTool.dateFormat(new Date(val.bookingDate), 'yyyy-MM-dd HH:mm');
					});
          sucRes.data.sort(function(a,b){
            return a.bookingDate > b.bookingDate ? 1 : -1
          });
					this.reportData = sucRes.data;
					for (let i = 0; i < this.reportData.length; i++) {
						this.totalPrice += this.reportData[i].TotalPrice;
						if (this.reportData[i].OrderType == 1 || this.reportData[i].OrderType == 3) {
							++this.shortCount;
						}
						if (this.reportData[i].OrderType == 2) {
							++this.longCount;
						}
					}
				}
			});
		},
		getReportData(dateTime) {
			this.reportData = [];
			this.limitDate = [];
			this.shortCount = 0;
			this.longCount = 0;
			this.totalPrice = 0;
			appointApi
				.getAppointOrderList(dateTime ? dateTime : this.startDate, dateTime ? dateTime : this.endDate, '', dateTime ? 'set' : this.dateType, this.token)
				.then(sucRes => {
					if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
						sucRes.data.forEach(val => {
              val.bookingDate = val.bookingDate.replace('T', ' ');
							// let tmpDate = val.bookingDate.replace('T', ' ');
							// let tmpDateStr = val.bookingDate.split(' ')[0];
							// let tmpTimeStr = val.bookingDate.split(' ')[1];
							// val.bookingDate = tmpDateStr + ' ' + tmpTimeStr.split(':')[0] + ':' + tmpTimeStr.split(':')[1];
							// val.bookingDate = baseTool.dateFormat(new Date(val.bookingDate), 'yyyy-MM-dd HH:mm');
						});
						this.reportData = sucRes.data;
						for (let i = 0; i < this.reportData.length; i++) {
							this.totalPrice += this.reportData[i].TotalPrice;
							if (this.reportData[i].OrderType == 1 || this.reportData[i].OrderType == 3) {
								++this.shortCount;
							}
							if (this.reportData[i].OrderType == 2) {
								++this.longCount;
							}
						}
					}
				});
		},
		getLimitDateList() {
			this.reportData = [];
			this.limitDate = [];
			appointApi.getAppointLimitDateList(this.limitType).then(sucRes => {
				if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
					sucRes.data.forEach(val => {
						val.LimitStartDate = baseTool.dateFormat(new Date(val.LimitStartDate), 'yyyy-MM-dd HH:mm');
						val.LimitEndDate = baseTool.dateFormat(new Date(val.LimitEndDate), 'yyyy-MM-dd HH:mm');
					});
					this.limitDate = sucRes.data;
				}
			});
		},
		invalidRecord(id) {
			appointApi.invalidPickupLimit(this.$store.state.user.OpenId, id).then(sucRes => {
				if (sucRes.success) {
					alert(sucRes.message);
					this.getLimitDateList();
				} else {
					alert(sucRes.message);
				}
			});
		},
		addLimit() {
			appointApi.addLimit(this.$store.state.user.OpenId, this.startDate, this.endDate, this.startTime, this.endTime, this.limitType, this.isGo).then(sucRes => {
				if (sucRes.success) {
					alert(sucRes.message);
					this.getLimitDateList();
				} else {
					alert(sucRes.message);
				}
			});
		},
		bindDriverToAppointOrder(item) {
			let that = this;
			this.DriverList = [];
      this.hisDriverTable = [];
			for (let i = 0; i < this.driverList.length; i++) {
				let driverTmp = {
					label: this.driverList[i].DriverName,
					value: this.driverList[i].DriverName
				};
				this.DriverList.push(driverTmp);
			}
      console.log('item',item)
      if(item.FromOrderNum != ''){
        appointApi.GetUserHistoryOrderByApp(item.UserID,0,item.FromOrderNum).then(hisBisRes => {
          console.log('车票hisBisRes',hisBisRes)
          this.busPeople = hisBisRes.data.OrderList_InfoList[0].RealName;
          this.busPhone = hisBisRes.data.OrderList_InfoList[0].Mobile;
          this.busTime = hisBisRes.data.OrderList_InfoList[0].OrderList_InfoFrequencyList[0].SetTime.replace("T", "  ");
        })
      }
      else{
        this.busPeople = '无';
        this.busPhone = '无';
        this.busTime = '无';
      }
      appointApi.GetUserHistoryOrderByApp(item.UserID,1,'').then(hisCarRes => {
        console.log('约车hisCarRes',hisCarRes)
        if(hisCarRes.totalCount > 1){
          var nameArr = [];
          for(var i=1;i<=hisCarRes.totalCount-1;i++){
            hisCarRes.data[i].bookingDate = hisCarRes.data[i].bookingDate.replace("T", "  ");
            nameArr.push(hisCarRes.data[i]);
            // this.hisDriverTable = this.hisDriverTable.push(hisCarRes.data[i]);
            // nameArr.push(hisCarRes.data[i].DriverName);
            // this.carDriver += hisCarRes.data[i].DriverName + ';'
          }
          this.hisDriverTable = nameArr;
          console.log('hisDriverTable',this.hisDriverTable)
          // this.carDriver = nameArr.join(";");;
          // this.carTime = hisCarRes.data[1].bookingDate.replace("T", "  ");
        }
        else if(hisCarRes.totalCount == 1){
          this.hisDriverTable = [];
          // this.carTime = '无';
          // this.carDriver = '无';
        }
      })

      item.CreateDate = item.CreateDate.replace("T", "  ")
      this.customInfo = item;
      this.showinfo = true;

		},
    Isok(){
      var that = this;
      this.showinfo = false;
      this.$weui.picker(this.DriverList, {
      	onConfirm: result => {
      		let driverName = result[0].value;
      		let orderId = this.customInfo.ID;
      		that.orderModal.Show = true;
      		that.orderModal.DriverName = driverName;
      		that.orderModal.OrderId = orderId;
      	}
      });
    },
		bindOrderToDriver(driverName, orderId, isBind) {
			appointApi.bindDriverToAppointOrder(this.$store.state.user.OpenId, driverName, orderId, isBind, '').then(sucRes => {
				if (sucRes.success) {
					for (let i = 0; i < this.reportData.length; i++) {
						if (this.reportData[i].ID == this.customInfo.ID) {
							this.reportData[i] = sucRes.data;
						}
					}
          alert(sucRes.message);
				} else {
					alert(sucRes.message);
				}
			});
		},
	},
	computed: mapState({
		OpenId: state => state.user.OpenId,
		totalShortGoCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.shortGoCount;
				});
			}
			return total;
		},
		totalShortBackCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.shortBackCount;
				});
			}
			return total;
		},
		totalLongGoCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.longGoCount;
				});
			}
			return total;
		},
		totalLongBackCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.longBackCount;
				});
			}
			return total;
		}
	})
};
</script>

<style scoped="scoped" type="text/css">
.title {
	width: 100%;
	background-color: #005242;
	text-align: center;
}
.title h1 {
	width: 100%;
	line-height: 10vh;
	color: #fff;
	font-size: 0.5rem;
}
.filtrate_wrap {
	width: 100%;
	border-top: 5px solid #f8f8f8;
	padding: 0.2rem 0;
}
.filtrate_wrap > div {
	margin: 0.2rem 0 0.2rem 0.3rem;
}
.select_wrap,
.date_wrap,
.btn_wrap {
	align-self: stretch;
	height: 4vh;
	position: relative;
}
.select,
.date {
	box-sizing: border-box;
	align-self: stretch;
	background-color: #555;
	font-size: 0.35rem;
	outline: none;
	color: #fff;
	border: 1px solid #888;
}

.select {
	width: 100%;
}

.date_wrap > span {
	margin: 0 0.2rem;
	color: #fff;
}
.demand_btn {
	background-color: #f8f8f8;
	color: #333;
}
.demand_btn:active {
	background-color: #ddd;
	color: #555;
}

.index_content {
	width: 100%;
	flex: 1;
	padding: 0.2rem;
	overflow-y: scroll;
}
.table {
}
.bg_tr {
	background-color: #888;
}
.tr {
	color: #fff;
}
.td {
	color: #888;
}
.statistics_table .tr:last-child .td {
	color: #fff;
}
.bg_huizong {
	background-color: #2fdab9;
}

.tong_ji {
	border-bottom: 1px solid #888;
}
.index_content h3:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.index_content h3 {
	text-align: center;
	color: #fff;
	line-height: 4vh;
	background-color: #06967a;
}

body,
ol,
ul,
h1,
h2,
h3,
h4,
h5,
h6,
p,
th,
td,
dl,
dd,
form,
fieldset,
legend,
input,
textarea,
select {
	margin: 0;
	padding: 0;
}
body {
	font: 12px/24px '微软雅黑', 'Arial Narrow', HELVETICA;
	-webkit-text-size-adjust: 100%;
}
a {
	color: #2d374b;
	text-decoration: none;
}
a:hover {
	color: #cd0200;
	text-decoration: underline;
}
em {
	font-style: normal;
}
li {
	list-style: none;
}
button,
input {
	outline: none;
}
img {
	border: 0;
	vertical-align: middle;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
div {
	box-sizing: border-box;
}
p {
	word-wrap: break-word;
}

html {
	height: 100%;
}

body {
	margin: 0 auto;
	width: 10rem;
	height: 100%;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
}
.page_container {
	width: 100%;
	height: 100%;
	margin: 0 auto;
}
.flex_wrap {
	display: flex;
}
.row {
	flex-direction: row;
}
.column {
	flex-direction: column;
}
.wrap {
	flex-wrap: wrap;
}
.j_c_center {
	justify-content: center;
}
.j_c_start {
	justify-content: flex-start;
}
.j_c_end {
	justify-content: flex-end;
}
.j_c_around {
	justify-content: space-around;
}
.j_c_between {
	justify-content: space-between;
}
.a_i_center {
	align-items: center;
}
.a_i_start {
	align-items: flex-start;
}
.a_i_end {
	align-items: flex-end;
}

.btn {
	outline: none;
	border: 1px solid #888;
	border-radius: 4px;
}

.table {
	width: 100%;
	border: 1px solid #aaa;
}
.table:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.tr {
	justify-content: space-around;
	align-items: center;
	flex: 1;
}
.th:nth-last-child(n + 2),
.td:nth-last-child(n + 2) {
	border-right: 1px solid #ddd;
}
.tr:nth-last-child(n + 2) {
	border-bottom: 1px solid #ddd;
}
.th,
.td {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	flex-wrap: wrap;
	word-break: break-all;
	text-align: center;
}
.td {
	padding: 0.1rem;
}

@font-face {
	font-family: 'iconfont';
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot');
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.woff') format('woff'),
		url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.ttf') format('truetype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.svg#iconfont') format('svg');
}
.iconfont {
	font-family: 'iconfont' !important;
	/*font-size:40rpx;*/
	margin: 0 5px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.iconreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(-1);
}
.noticonreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(1);
}
.showinfo p{
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/PickupReportList.vue